import { RouteObject } from 'react-router-dom';
import { appPaths } from 'consts/paths/paths';
import { EnrollmentAdd, EnrollmentSuccess, EnrolmentItem } from 'pages';
import { CentralIslandLayoutWithOutlet, EnrollmentLayout } from 'components/layouts/';

export const enrollmentRoutes: RouteObject = {
    path: appPaths.enrollment.base,
    element: <EnrollmentLayout />,
    children: [
        {
            element: <CentralIslandLayoutWithOutlet />,
            children: [
                { path: appPaths.enrollment.item, element: <EnrolmentItem /> },
                { path: appPaths.enrollment.success, element: <EnrollmentSuccess /> },
            ],
        },
        {
            element: <CentralIslandLayoutWithOutlet fillSpaceWithIsland />,
            children: [{ path: appPaths.enrollment.add, element: <EnrollmentAdd /> }],
        },
    ],
};
